import { BUSCAR_CENTROS_CUSTO, TIPO_CENTRO_CUSTO_SELECIONADO, TIPOS_OCORRENCIA_CENTRO_CUSTO_CARREGADOS, CENTRO_CUSTO_SELECIONADO } from '../../actions/centro-custo';
import {ALTERAR_DETALHAMENTO_CENTRO_CUSTO} from '../../actions/centro-custo/alterarExibicaoDetalhamentoCentroCusto';
import { TOTALIZADORES_CENTRO_CUSTO } from '../../actions/centro-custo/buscarTotalizadoresCentroCusto';

const estadoInicial = {
    listaCentroCusto: [],
    centroCustoSelecionado: {},
    tiposCentroCusto: [],
    totalizadores: {},
};

export default function (state = estadoInicial, action) {
    switch (action.type) {
        case BUSCAR_CENTROS_CUSTO:
            return {
                ...state,
                listaCentroCusto: action.payload.registros.map(centroCusto => Object.assign({}, centroCusto, { exibirDetalhe: false, selecionado: false })),
                totalCentroCusto: action.payload.total || 0
            };
        case TIPO_CENTRO_CUSTO_SELECIONADO:
            return {
                ...state,
                centroCustoSelecionado: action.payload || {}
            };

        case TIPOS_OCORRENCIA_CENTRO_CUSTO_CARREGADOS:
            return {
                ... state,
                tiposCentroCusto: action.payload
            };
        case CENTRO_CUSTO_SELECIONADO:
            return {
                ...state,
                centroCustoSelecionado: action.payload
            };

        case ALTERAR_DETALHAMENTO_CENTRO_CUSTO: {
            const centroCusto = action.payload;
            const indice = state.listaCentroCusto.indexOf(centroCusto);
            const novoCentroCusto= Object.assign({}, centroCusto, { exibirDetalhe: !centroCusto.exibirDetalhe });
            const listaCentroCusto = Object.assign([], state.listaCentroCusto);
            listaCentroCusto[indice] = novoCentroCusto;

            return {
                ...state,
                listaCentroCusto,
            };
        }

        case TOTALIZADORES_CENTRO_CUSTO:
            return {
                ...state,
                totalizadores: action.payload
            };

        case 'LIMPAR_FILTROS_CENTRO_CUSTO':
            return {
                ...state,
                centroCustoSelecionado: {}
            };


        default:
            return state;
    }
}
